@if (list.multipleElementTemplate[column.key]) {

  <ng-container *ngIf="row[column.key]">
    <span *ngIf="row[column.key].length === undefined">{{ row[column.key][list.multipleElementTemplate[column.key]] }}</span>

    <div i18n="@@Deleted" *ngIf="row[column.key]?.deleted" class="badge" style="clear: both">удален</div>

    <span class="relationTpl" *ngIf="row[column.key].length">
        <ng-container *ngFor="let listItem of row[column.key]">
            <span class="badge">{{ listItem[list.multipleElementTemplate[column.key]] }} <span i18n="@@MinusDeleted" *ngIf="listItem?.deleted">-удален</span></span>
        </ng-container>
    </span>
  </ng-container>

} @else if (column.key == 'action') {

  <div i18n="@@RecordDeleted" *ngIf="row.deleted" class="badge" style="clear: both">запись удалена</div>
  <div class="editButtons">
    <button type="button" *ngIf="list.editCondition(row)&&list.uriView===list.uri" i18n-title="@@Edit" [routerLink]="['edit/', row.id]" title="редактировать" nbButton status="control">
      <nb-icon icon="edit-outline"></nb-icon>
    </button>
    <a *ngIf="list.editCondition(row)&&list.uriView!==list.uri" i18n-title="@@Edit" href="{{list.uriView}}/{{row.id}}" title="редактировать" nbButton status="control">
      <nb-icon icon="edit-outline"></nb-icon>
    </a>
    <button type="button" *ngIf="row.deleted !== true && list.deleteCondition(row)" i18n-title="@@Delete" (click)="list.onDeleteConfirm(row.id, row)" title="удалить" nbButton status="control">
      <nb-icon icon="close"></nb-icon>
    </button>
  </div>

} @else if ((column.key == 'header' || (row['header'] === undefined && colIndex == 0)) && list.editCondition(row)) {
  @if (list.uriView !== list.uri) {
    <a [routerLink]="[list.uriView, row.id]">{{ row | render: column.key }}</a>
  } @else {
    <a [routerLink]="['edit/', row.id]">{{ row | render: column.key }}</a>
  }

} @else if (column.key == 'youtube-preview') {
  <a [href]="row.link" target="_blank"> <img [src]="list.getYouTubeVideoSrc(row)" alt=""> </a>

} @else if (column.type == 'date') {
  {{ row[column.key] | date: 'dd.MM.yyyy' }}

} @else if (column.type == 'date-timepicker-input') {
  {{ row[column.key] | date: 'dd.MM.yyyy HH:mm:ss' }}

} @else if (column.type == 'checkbox' && column.key == 'enabled') {
  <nb-toggle [(checked)]="row.enabled" (checkedChange)="list.onEnabled($event, row.id)"/>

} @else {
  {{ row | render: column.key }}
}


